import { React, useState, useEffect } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox } from "antd";
import Iconmoon from "../../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  ProductionSet,
} from "../../../styledElements";
import RightDrawerSidebar from "../../../../Components/RightDrawer/rightDrawer";
import { DatePicker } from "antd";
import { DatePickerY, GlobalSet, DisabledStyles } from "../../../pageStyled";
import { getParentReelDetails } from "../../../../Services/productionPlanningServices";
import moment from "moment";
import { lengthUnit, weightUnit } from "../../../../Utils/Constant/MeasurementUnitList";

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const { Option } = Select;
const { TextArea } = Input;

const ParentJumboReelDrawer = (props) => {
  const [details, setDetails] = useState();
  useEffect(() => {
    if (props.selectedJR) {
      getParentReelDetails(props.selectedJR)
        .then((resp) => {
          setDetails(resp.data.data);
        })
        .catch((err) => {});
    }
  }, [props]);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return details ? (
    <RightDrawerSidebar
      title={details?.machine_type !== "cutter" ? `Parent Reel - ${props.selectedJR}` : `Parent Set - ${props.selectedJR}`}
      subtitle={`Weight: ${details.weight.toFixed(3)} ${" "} ${(details.units && details.units.weight) ? capitalize(weightUnit[details.units.weight]?.displayName) : "T"}`}
      visible={props.visible}
      onClose={() => {
        props.onCloseJumboReel();
      }}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
              >
                <div
                  className="drawerField"
                  style={{ paddingTop: "5px", paddingBottom: "15px" }}
                >
                  <div className="titleWithText titlebytwo">
                    <h5>Jumbo Reels</h5>
                    {details.mapped_jumbo_reels_info.map((item) => {
                      return (
                        <p>{`${item.number} (${item.weight_utilized} ${" "} ${(details.units && details.units.weight)? capitalize(weightUnit[details.units.weight]?.displayName) : "T"})`}</p>
                      );
                    })}
                  </div>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Mapping Date</h5>
                    <p>The parent reel was mapped on selected date</p>
                  </div>
                  <DatePickerY>
                    <Form.Item
                      name="Date"
                      initialValue={details.mapped_date ? moment(details.mapped_date, "YYYY-MM-DD") : ''}
                    >
                      <DatePicker format={"DD/MM/YYYY"} />
                    </Form.Item>
                  </DatePickerY>
                </div>

                {details.status === "mapped" && (
                  <div className="drawerField removeStar">
                    {details?.machine_type !== "cutter" ? (
                      <div className="titleWithText">
                        <h5>Rewinding Date and Shift</h5>
                        <p>
                          The parent reel will be rewinded on selected date and
                          shift
                        </p>
                      </div>) : (
                      <div className="titleWithText">
                        <h5>Cutting Date and Shift</h5>
                        <p>
                          The parent set will be cut on selected date and
                          shift
                        </p>
                      </div>)}
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={11}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <DatePickerY>
                          {details?.machine_type !== "cutter" ? (<Form.Item
                              label="Date"
                              name="RewindingDate"
                              className="dBlock"
                              initialValue={details.rewinding_date? moment(
                                details.rewinding_date,
                                "YYYY-MM-DD"
                              ) : ""}
                            >
                              <DatePicker
                                format={"DD-MM-YYYY"}
                                disabledDate={(current) => {
                                  let customDate =
                                    moment().format("YYYY-MM-DD");
                                  return (
                                    current &&
                                    current < moment(customDate, "YYYY-MM-DD")
                                  );
                                }}
                              />
                            </Form.Item>) : (
                              <Form.Item
                              label="Date"
                              name="CuttingDate"
                              className="dBlock"
                              initialValue={details.cutting_date? moment(
                                details.cutting_date,
                                "YYYY-MM-DD"
                              ) : ""}
                            >
                              <DatePicker
                                format={"DD-MM-YYYY"}
                                disabledDate={(current) => {
                                  let customDate =
                                    moment().format("YYYY-MM-DD");
                                  return (
                                    current &&
                                    current < moment(customDate, "YYYY-MM-DD")
                                  );
                                }}
                              />
                            </Form.Item>
                            )}
                          </DatePickerY>
                        </div>
                      </Col>
                      <Col span={11}>
                        <div className="boxFormType">
                        {details?.machine_type !== "cutter" ? (<Form.Item
                            label="Shift"
                            name="Shift"
                            initialValue={details.rewinding_shift? details.rewinding_shift : ""}
                            rules={[{ required: true }]}
                            className="dBlock"
                          >
                            <Input placeholder="Text" disabled />
                          </Form.Item>) : (
                            <Form.Item
                            label="Shift"
                            name="Shift"
                            initialValue={details.cutting_shift? details.cutting_shift : ""}
                            rules={[{ required: true }]}
                            className="dBlock"
                          >
                            <Input placeholder="Text" disabled />
                          </Form.Item>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                {details.status === "produced" && (
                  <div className="drawerField">
                    <div className="titleWithText">
                      <h5>Production Completion Date</h5>
                      <p>
                        The production of this parent reel was completed on
                        selected date
                      </p>
                    </div>
                    <div className="boxFormType">
                      <DatePickerY>
                        <Form.Item
                          name="ProdDate"
                          initialValue={
                            details.production_date
                              ? moment(details.production_date, "YYYY-MM-DD")
                              : null
                          }
                        >
                          <DatePicker format={"DD/MM/YYYY"} />
                        </Form.Item>
                      </DatePickerY>
                    </div>
                  </div>
                )}
                <div className="drawerField">
                {details?.machine_type !== "cutter" ? (
                  <div className="titleWithText">
                    <h5>Reels</h5>
                    <p>
                      All the child reels of this parent reel can be viewed here
                    </p>
                  </div>) : (
                    <div className="titleWithText">
                    <h5>Sheets</h5>
                    <p>
                      All the child sheets of this parent set can be viewed here
                    </p>
                  </div>
                  )}
                  <div className="prod-reelset">
                    {details.reels.map((reel) => {
                      return (
                        <ProductionSet>
                          <div className="prodset-header">
                            <Iconmoon
                              icon={details?.machine_type === "cutter" ? "sheet" : "tissue-role"}
                              size={28}
                              color="#EA655B"
                            />
                            <div className="prodleft-header">
                              <h4>
                                {`${reel.id}`}{" "}
                                {reel.priority && (
                                  <span dataset="Priority">Priority</span>
                                )}
                              </h4>
                              {reel.reel_type == "order" && (
                                <label>{`Delivery Date: ${moment(
                                  reel.delivery_date
                                ).format("DD-MM-YYYY")}`}</label>
                              )}
                            </div>
                          </div>
                          <div className="prodset-body">
                            {reel.reel_type == "order" ? (
                              <div>
                                <div className="prodset-dt">
                                  <h5>PO NO.:</h5>
                                  <p>{`${reel.po}`}</p>
                                </div>
                                <div className="prodset-dt">
                                  <h5>ORDER NO.:</h5>
                                  <p>{`${reel.order}`}</p>
                                </div>
                              </div>
                            ) : (
                              <div className="prodset-dt">
                                <h5>STOCK NO.:</h5>
                                <p>{`${reel.stock}`}</p>
                              </div>
                            )}
                            <div className="d-flex prodset-sb">
                              <div className="prodset-dt prod-50">
                                <h5>Weight:</h5>
                                <p>{`${reel.weight}${" "}${(reel.units && reel.units.weight) ? capitalize(weightUnit[reel.units.weight]?.displayName) : "T"}`}</p>
                              </div>
                              <div className="prodset-dt prod-50">
                                <h5>Size:</h5>
                                <p>{`${reel.size} ${" "}${(reel.units && reel.units.size) ? lengthUnit[reel.units.size]?.displayName?.toUpperCase() : "T"}`}</p>
                              </div>
                            </div>
                          </div>
                          <div className="prodset-footer">
                            <label>Production Status</label>
                            <span
                              dataset={`${capitalizeFirstLetter(reel.status)}`}
                            >{`${capitalizeFirstLetter(reel.status)}`}</span>
                          </div>
                        </ProductionSet>
                      );
                    })}
                    {/* <ProductionSet>
                                            <div className="prodset-header">
                                                <Iconmoon icon="tissue-role" size={28} color="#EA655B" />
                                                <div className="prodleft-header">
                                                    <h4>HW124785401A <span dataset="Priority">Priority</span></h4>
                                                    <label>Delivery Date: 15-05-2022</label>
                                                </div>
                                            </div>
                                            <div className="prodset-body">
                                                <div className="prodset-dt">
                                                    <h5>PO NO.:</h5>
                                                    <p>HW1248745</p>
                                                </div>
                                                <div className="prodset-dt">
                                                    <h5>ORDER NO.:</h5>
                                                    <p>1248745</p>
                                                </div>
                                                <div className="d-flex prodset-sb">
                                                    <div className="prodset-dt prod-50">
                                                        <h5>Weight:</h5>
                                                        <p>2 Tonnes</p>
                                                    </div>
                                                    <div className="prodset-dt prod-50">
                                                        <h5>Size:</h5>
                                                        <p>180 CM</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="prodset-footer">
                                                <label>Production Status</label>
                                                <span dataset="Produced">Produced</span>
                                            </div>
                                        </ProductionSet>
                                        <ProductionSet>
                                            <div className="prodset-header">
                                                <Iconmoon icon="tissue-role" size={28} color="#EA655B" />
                                                <div className="prodleft-header">
                                                    <h4>HW124785401A <span dataset="Priority">Priority</span></h4>
                                                    <label>Delivery Date: 15-05-2022</label>
                                                </div>
                                            </div>
                                            <div className="prodset-body">
                                                <div className="prodset-dt">
                                                    <h5>PO NO.:</h5>
                                                    <p>HW1248745</p>
                                                </div>
                                                <div className="prodset-dt">
                                                    <h5>ORDER NO.:</h5>
                                                    <p>1248745</p>
                                                </div>
                                                <div className="d-flex prodset-sb">
                                                    <div className="prodset-dt prod-50">
                                                        <h5>Weight:</h5>
                                                        <p>2 Tonnes</p>
                                                    </div>
                                                    <div className="prodset-dt prod-50">
                                                        <h5>Size:</h5>
                                                        <p>180 CM</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="prodset-footer">
                                                <label>Production Status</label>
                                                <span dataset="Produced">Produced</span>
                                            </div>
                                        </ProductionSet>
                                        <ProductionSet>
                                            <div className="prodset-header">
                                                <Iconmoon icon="tissue-role" size={28} color="#EA655B" />
                                                <div className="prodleft-header">
                                                    <h4>HW124785401A <span dataset="Priority">Priority</span></h4>
                                                    <label>Delivery Date: 15-05-2022</label>
                                                </div>
                                            </div>
                                            <div className="prodset-body">
                                                <div className="prodset-dt">
                                                    <h5>PO NO.:</h5>
                                                    <p>HW1248745</p>
                                                </div>
                                                <div className="prodset-dt">
                                                    <h5>ORDER NO.:</h5>
                                                    <p>1248745</p>
                                                </div>
                                                <div className="d-flex prodset-sb">
                                                    <div className="prodset-dt prod-50">
                                                        <h5>Weight:</h5>
                                                        <p>2 Tonnes</p>
                                                    </div>
                                                    <div className="prodset-dt prod-50">
                                                        <h5>Size:</h5>
                                                        <p>180 CM</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="prodset-footer">
                                                <label>Production Status</label>
                                                <span dataset="Mapped">Mapped</span>
                                            </div>
                                        </ProductionSet> */}
                  </div>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : (
    <></>
  );
};

export default ParentJumboReelDrawer;
